(function($) {

	$("#click-category").click(function(){

		$(".c-submenu").addClass("show-submenu");
		$("#click-category-bottom").addClass("show");
		$("#click-category").addClass("hide");

	});

	$("#click-category-bottom").click(function(){

		$(".c-submenu").removeClass("show-submenu");
		$("#click-category-bottom").removeClass("show");
		$("#click-category").removeClass("hide");

	});

})(jQuery);

